import { Navigate, useParams, useLocation } from "react-router-dom";

export function RedirectWithParams({ to }: { to: string }) {
  const params = useParams();
  const location = useLocation();
  const path = Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, value || ""),
    to
  );
  return <Navigate to={path + location.search} replace />;
}

export function RedirectChildToPanel() {
  const { id } = useParams();
  return <Navigate to={`/?panel=families&tab=children&id=${id}`} replace />;
}

export function RedirectInvoiceToPanel() {
  const { id } = useParams();
  return <Navigate to={`/?panel=billing&tab=invoices&id=${id}`} replace />;
}

